const API_URL =
  process.env.NEXT_PUBLIC_API_URL ?? "http://localhost:4000/graphql";

function getSessionId(): string {
  if (typeof window === "undefined") return "server";
  const key = "bacha_ai_session_id";
  let id = window.localStorage.getItem(key);
  if (!id) {
    id = crypto.randomUUID();
    window.localStorage.setItem(key, id);
  }
  return id;
}

async function callGraphQL(query: string, variables: any) {
  try {
    await fetch(API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query, variables })
    });
  } catch (e) {
    console.error("tracking error", e);
  }
}

export function trackPageView(path: string) {
  if (typeof window === "undefined") return;
  const sessionId = getSessionId();
  const mutation = `
    mutation TrackPageView($input: PageViewInput!) {
      trackPageView(input: $input)
    }
  `;
  const referrer = document.referrer || null;
  const userAgent = navigator.userAgent;

  callGraphQL(mutation, {
    input: {
      sessionId,
      path,
      referrer,
      userAgent
    }
  });
}

export function trackClickEvent(
  eventName: string,
  path: string,
  elementLabel?: string
) {
  if (typeof window === "undefined") return;
  const sessionId = getSessionId();
  const mutation = `
    mutation TrackClickEvent($input: ClickEventInput!) {
      trackClickEvent(input: $input)
    }
  `;

  callGraphQL(mutation, {
    input: {
      sessionId,
      path,
      eventName,
      elementLabel: elementLabel || null
    }
  });
}
